import JsonApiResponseConverter from 'json-api-response-converter';
import { ActionTree } from 'vuex';
import EmptyState from '@/store/EmptyState';
import LocationRepository from '@/repositories/LocationRepository';
import RootState from '@/store/RootState';

const actions: ActionTree<EmptyState, RootState> = {
    async fetch({ commit }): Promise<void> {
        const locationRepository = new LocationRepository();
        const response = await locationRepository.index();
        const locations = new JsonApiResponseConverter(response).formattedResponse;

        commit('setLocations', locations);
    },
};

export default actions;
